import React from 'react';
import one from '../img/erp (1).png';
import two from '../img/crm.png';
import three from '../img/pos.png';

const Products = () => {
  return (
    <section className="services" id="services">
      <h2>Our Products</h2>
      <p className="section-desc">
        JRP Soft Tech delivers scalable, secure, and industry-ready software products designed to streamline operations, improve decision-making, and accelerate business growth across industries.
        <br/>
        Our products are developed using modern technologies, secure architectures, and industry best practices, making them ideal for startups, SMEs, and large enterprises.
    </p>

      <div className="row">
        <div className="column">
          <img src={one} alt="JRP Soft Tech" />
          <h3>ERP Software (Enterprise Resource Planning)</h3>
          <p><b>One platform to manage your entire business</b><br/>
JRP ERP is an integrated enterprise management solution designed to streamline and automate core business operations including finance, inventory, procurement, HR, production, and project management through a single unified platform, enabling organizations to improve efficiency, gain real-time insights, reduce operational costs, and scale seamlessly across departments, locations, and industries.
</p>
          <div className="services-btn">
            <a href="https://wa.me/917977874412">
              <button className="btn secondary-btn">Learn More</button>
            </a>
          </div>
        </div>
        
        <div className="column">
          <img src={two} alt="JRP Soft Tech" />
          <h3>JRP CRM (Customer Relationship Management)</h3>
          <p><b>Build Stronger Customer Relationships</b>
          <br/>JRP CRM is a powerful customer and sales management system that helps businesses capture leads, manage customer interactions, automate sales pipelines, track follow-ups, and deliver exceptional customer experiences, while providing actionable analytics to improve conversions, retention, and overall sales performance.
          </p>
          <div className="services-btn">
            <a href="https://wa.me/917977874412">
              <button className="btn secondary-btn">Learn More</button>
            </a>
          </div>
        
        </div>

        <div className="column">
          <img src={three} alt="JRP Soft Tech" />
          <h3>JRP POS (Point of Sale System)</h3>
          <p><b>Smart Billing & Retail Management Solution</b><br/>
            JRP POS is a fast, reliable, and GST-ready billing and retail management solution built to simplify sales transactions, manage inventory, monitor stock levels, generate real-time reports, and support multi-store operations, making it ideal for retail outlets, restaurants, and growing businesses seeking accuracy and speed.
          </p>
          <div className="services-btn">
            <a href="https://wa.me/917977874412">
              <button className="btn secondary-btn">Learn More</button>
            </a>
          </div>
        </div>

        </div>
      

    </section>
  );
};

export default Products;
